var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isConnected && _vm.billTotal > 0
      ? _c(
          "div",
          [
            _c("vue-stripe-checkout", {
              ref: "checkoutRef",
              attrs: {
                image: _vm.image,
                name: _vm.name,
                description: _vm.description,
                currency: _vm.currency,
                amount: _vm.amount,
                "allow-remember-me": false,
              },
              on: { done: _vm.done },
            }),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "stripe-payment-trigger",
                attrs: { disabled: _vm.disabled },
                on: { click: _vm.checkout },
              },
              [_vm._v("\n      Pay With Card\n    ")]
            ),
          ],
          1
        )
      : _c(
          "span",
          { attrs: { id: "payment-disabled" } },
          [
            _c(
              "b-button",
              {
                staticClass: "stripe-payment-trigger",
                attrs: { disabled: "" },
              },
              [_vm._v("Pay With Card")]
            ),
            _vm._v(" "),
            !_vm.isConnected
              ? _c("b-tooltip", {
                  attrs: {
                    target: "payment-disabled",
                    placement: "top",
                    title: "Cannot charge without internet connection",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.billTotal <= 0
              ? _c("b-tooltip", {
                  attrs: {
                    target: "payment-disabled",
                    placement: "top",
                    title: "Total charge must be greater than zero",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }